import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IInduccionProgramarModel } from 'src/app/models/interfaces/induccion/IInduccionModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';

@Component({
  selector: 'app-induccion-programar-dialog',
  templateUrl: './induccion-programar-dialog.component.html',
  styleUrls: ['./induccion-programar-dialog.component.css']
})
export class InduccionProgramarDialogComponent implements OnInit {
  
  constructor(    
    public dialogRef: MatDialogRef<InduccionProgramarDialogComponent>,
    private induccionService: InduccionService,
    @Inject(MAT_DIALOG_DATA) public model: IInduccionProgramarModel
  ) { 
  
  }

  ngOnInit(): void {
    this.model.fechaInduccion = new Date();
    this.model.fechaInduccion.setHours(0,0,0,0);
  }

  Save(): void {
       
  }

  onSubmit(form: NgForm) {
    // console.log(this.data.persona.documentos);
    if (!form.invalid) {      
      this.induccionService.programar(this.model).subscribe(p => {
        this.dialogRef.close(true);
      }); 
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
